import { createApp } from 'vue'
import { createGtm } from 'vue-gtm';

import App from './App.vue'
import router from './router'
import Balados from "./stores/balados.js";

const app = createApp(App)
app.use(router)

app.use(createGtm({
  id: 'GTM-5PH7N6Z', // or ['GTM-xxxxxx', 'GTM-yyyyyy'], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview:'env-4',
  //   gtm_cookies_win:'x'
  // },
  // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  // compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  // enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
  // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
}));

app.config.globalProperties.balados = Balados[0]

router.beforeEach((to,from,next) => {
  // // console.log('from',from)
  // let metaTitle = "", metaDesc = "", ogImage = "https://appui-audeladesmots.ca/images/og-image.jpg";

  // if (to.name == 'BaladoSingle' ) {
  //   ogImage = Balados[0][to.params.slug].image
  // }

  // document.title = metaTitle
  // document.querySelector('meta[name="description"]').setAttribute("content", metaDesc)
  // document.querySelector('meta[property="og:image"]').setAttribute("content", ogImage)

  next()
})

app.mount('#app');
